"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateGalleryListResponseToJSON = exports.TemplateGalleryListResponseFromJSONTyped = exports.TemplateGalleryListResponseFromJSON = exports.instanceOfTemplateGalleryListResponse = exports.attributeTypeMapTemplateGalleryListResponse = void 0;
var TemplateGalleryListItemResponse_1 = require("./TemplateGalleryListItemResponse");
exports.attributeTypeMapTemplateGalleryListResponse = [
    {
        name: "page",
        type: "number",
    },
    {
        name: "numPages",
        type: "number",
    },
    {
        name: "numResults",
        type: "number",
    },
    {
        name: "pageSize",
        type: "number",
    },
    {
        name: "templates",
        type: "Array<TemplateGalleryListItemResponse>",
    },
];
/**
 * Check if a given object implements the TemplateGalleryListResponse interface.
 */
function instanceOfTemplateGalleryListResponse(value) {
    if (!("page" in value) || value["page"] === undefined)
        return false;
    if (!("numPages" in value) || value["numPages"] === undefined)
        return false;
    if (!("numResults" in value) || value["numResults"] === undefined)
        return false;
    if (!("pageSize" in value) || value["pageSize"] === undefined)
        return false;
    if (!("templates" in value) || value["templates"] === undefined)
        return false;
    return true;
}
exports.instanceOfTemplateGalleryListResponse = instanceOfTemplateGalleryListResponse;
function TemplateGalleryListResponseFromJSON(json) {
    return TemplateGalleryListResponseFromJSONTyped(json, false);
}
exports.TemplateGalleryListResponseFromJSON = TemplateGalleryListResponseFromJSON;
function TemplateGalleryListResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        page: json["page"],
        numPages: json["num_pages"],
        numResults: json["num_results"],
        pageSize: json["page_size"],
        templates: json["templates"].map(TemplateGalleryListItemResponse_1.TemplateGalleryListItemResponseFromJSON),
    };
}
exports.TemplateGalleryListResponseFromJSONTyped = TemplateGalleryListResponseFromJSONTyped;
function TemplateGalleryListResponseToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        page: value["page"],
        num_pages: value["numPages"],
        num_results: value["numResults"],
        page_size: value["pageSize"],
        templates: value["templates"].map(TemplateGalleryListItemResponse_1.TemplateGalleryListItemResponseToJSON),
    };
}
exports.TemplateGalleryListResponseToJSON = TemplateGalleryListResponseToJSON;
